module.exports = {
	"title": "預約內容確認頁",
	"privacyPolicy": "隱私權政策",
	"term": "服務使用條款",
	"phoneNumberText": "請輸入您預約時的電話號碼。",
	"phoneNumber": "電話號碼",
	"phoneNumberError": "搜尋不到預約記錄，請確認電話號碼是否有誤。(無法確認已過期的預約。)",
	"phoneNumberEnabledButton": "確認預約內容",
	"phoneNumberDisabledButton": "輸入您的電話號碼",
	"reservationCanceled": "本預約已被取消。",
	"reservationCancel": "此預訂被取消。",
	"course": "套餐",
	"address": "地址",
	"phone": "店家聯絡方式",
	"contents": "預約內容",
	"date": "時間",
	"seats": "人數",
	"adults": "大人",
	"children": "小孩",
	"request": "需求與詢問",
	"reservationNumber": "預約編號",
	"noText": "要取消或變更預約時，麻煩請直接來電告知，謝謝。",
	"cancelButton": "按此取消",
	"people": "人",
	"confirm": "確定取消預訂嗎？",
	"start": "開始",
	"deposit": "訂金",
	"table_category": "桌位類型",
	"private": "包廂",
	"counter": "吧檯",
	"table": "一般座位",
	"none": "無指定包廂",
	"yes": "是",
	"no": "否",
	"doCancel": "您確定要取消預約嗎？"
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/zh-tw.json
// module id = 171
// module chunks = 0